import { render } from "./WeeklyGross.vue?vue&type=template&id=138c9930"
import script from "./WeeklyGross.vue?vue&type=script&lang=js"
export * from "./WeeklyGross.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__